import 'antd/dist/antd.less'
import { ArrowIcon } from 'assets/icons'
import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import { selectUser } from 'slices/user.slice'
import { RWDContent, RWDHeader, RWDSidebar } from './index'
export const RWDashboard = (props: React.PropsWithChildren<unknown>) => {
  const { firstName, lastName, logo, role } = useSelector(selectUser)
  const userName = `${firstName} ${lastName}`
  const logoImage = `${logo}`
  const [isOpen, setIsOpen] = useState(false)
  const [width, setWidth] = useState(window.innerWidth)

  
  window.addEventListener(
    'resize',
    function () {
      setWidth(window.innerWidth)
      setIsOpen(false)
    },
    true,
  )
  const handleClose = () => {
    setIsOpen(false)
  }

  return (
    <div>
      <span
        className={`${
          width <= 937 ? 'block' : 'hidden'
        }  fixed top-[105px] bg-rw-color rounded-sm hover:cursor-pointer ${
          isOpen ? 'left-[250px]' : 'left-[0px]'
        } z-30 ease-linear duration-300`}
        onClick={() => setIsOpen(!isOpen)}
      >
        <ArrowIcon className={`${isOpen ? 'rotate-180' : ''} fill-white ease-linear duration-300`} />
      </span>
      <RWDHeader
        role={role}
        userName={userName}
        onClick={handleClose}
        headerClassName={`${
          width <= 937 ? 'h-[50px]' : 'h-[70px]'
        }  flex justify-between  items-center  p-0 bg-white fixed top-0 w-screen z-10 drop-shadow-sm`}
        logoClassName={` ${width <= 937 ? 'w-[100%] h-auto' : ''}`}
        logoProfile={logoImage}
      />
      <RWDSidebar
        closeNav={handleClose}
        className={`fixed   w-[250px] z-20 h-screen 
        ${
          width <= 937 ? `${isOpen ? 'left-[0px]' : 'left-[-250px]'} ease-linear duration-300 top-[50px]` : 'top-[70px]'
        }`}
        role={role}
      />
      <div onClick={handleClose}>
        <RWDContent
          className={` ${width <= 937 ? 'pt-[70px]' : 'ml-[250px] pt-[94px]'} bg-rw-content px-6 min-h-screen  `}
        >
          {props.children}
        </RWDContent>
      </div>
    </div>
  )
}
